import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Input } from "@letsbit/milkylb";
import { CARD_TYPE } from "@letsbit/malcolmlb";

import { CardItem } from "components/HistoryInfiniteScroll/CardItem";
import { Modal } from "components/Modal";

import { messages } from "./messages";
import { CardsToIncludeSelectorProps } from "./types";

export const CardsToIncludeSelector: React.FC<CardsToIncludeSelectorProps> = ({
  title,
  cards,
  onConfirmSelection,
  selectedIdCards,
  dataCypressId,
}) => {
  const { formatMessage } = useIntl();
  const [selecting, setSelecting] = useState(false);
  const [interSelectedCards, setInterSelectedCards] = useState(
    new Set(selectedIdCards),
  );

  useEffect(() => {
    setInterSelectedCards(new Set(selectedIdCards));
  }, [selecting, selectedIdCards]);

  const handleCardClick = (card_id: string) => {
    if (interSelectedCards?.has(card_id)) {
      interSelectedCards.delete(card_id);
      setInterSelectedCards(interSelectedCards);
    } else {
      interSelectedCards.add(card_id);
      setInterSelectedCards(interSelectedCards);
    }
  };

  const onClickSelector = () => setSelecting(true);

  const formatSelectedCardNames = () => {
    if (!selectedIdCards) return undefined;

    return [...selectedIdCards]
      .map((cardId, index, array) => {
        const card = cards.find((c) => c.id === cardId);
        const cardName =
          card?.metadata?.name ||
          (card?.card_type.type === CARD_TYPE.VIRTUAL
            ? formatMessage(messages.virtualCard)
            : formatMessage(messages.physicalCard));

        if (index === array.length - 1) {
          return cardName;
        } else if (index === array.length - 2) {
          return `${cardName} y`;
        } else {
          return `${cardName},`;
        }
      })
      .join(" ");
  };

  return (
    <>
      <Modal
        classNameModalWrapper="letsbit-tight-modal"
        onDidDismiss={() => setSelecting(false)}
        isOpen={selecting}
      >
        <div className="flex h-full flex-col">
          {title}
          <div className="relative flex h-[85%] flex-col gap-y-2 overflow-y-auto pb-6 pl-1 pr-2 pt-1">
            {cards &&
              cards.length > 0 &&
              cards?.map((card) => (
                <CardItem
                  isSelected={selectedIdCards?.has(card.id)}
                  element={card}
                  className="hover:cursor-pointer"
                  key={card.id}
                  onClick={handleCardClick}
                  dataCypressId={`${card.id}-option`}
                />
              ))}
            <div className="sticky bottom-[calc(0px-1.6rem)]	h-[48px] w-full shrink-0 bg-gradient-to-t from-[var(--milkylb-color-neutral-100)] to-white/0" />
          </div>
          <Button
            className="mt-8 w-[200px] self-end"
            onClick={() => {
              if (interSelectedCards) {
                onConfirmSelection(interSelectedCards);
                setSelecting(false);
              }
            }}
          >
            <FormattedMessage {...messages.select} />
          </Button>
        </div>
      </Modal>
      <Input
        onClick={onClickSelector}
        data-cypress-id={dataCypressId}
        value={formatSelectedCardNames()}
        placeholder={formatMessage(messages.placeholder)}
        labelPlacement="floating"
      />
    </>
  );
};
